import Base from '@/models/Base'
import { AssetStatus } from '@/enum/AssetStatus'
import type { OwnershipType } from '@/enum/OwnershipType'
import type { IEquipment } from '@/interfaces'
import type { IAppUser } from '@/interfaces/app-user/IAppUser'
import type { IEquipmentDimensionSpecifications } from '@/interfaces/equipments/IEquipmentDimensionSpecifications'
import type { IEquipmentWheelsAndTiresSpecifications } from '@/interfaces/equipments/IEquipmentWheelsAndTiresSpecifications'
import AppUser from '@/models/AppUser'
import EquipmentDimensionSpecifications from './EquipmentDimensionSpecifications'
import EquipmentWheelsAndTiresSpecifications from './EquipmentWheelsAndTiresSpecifications'

class Equipment extends Base implements IEquipment {
  title: string

  identifier: string

  make: string

  model: string

  year: string

  type: string

  status: AssetStatus

  machineHours: number

  ownership: OwnershipType

  assignedEmployeeId: string

  assignedEmployee: IAppUser

  dimensionSpecifications: IEquipmentDimensionSpecifications

  wheelsAndTiresSpecifications: IEquipmentWheelsAndTiresSpecifications

  constructor(equipment?: any) {
    super(equipment)
    this.title = equipment?.title
    this.identifier = equipment?.identifier
    this.make = equipment?.make
    this.model = equipment?.model
    this.year = equipment?.year
    this.type = equipment?.type
    this.status = equipment?.status
    this.machineHours = equipment?.machineHours
    this.ownership = equipment?.ownership
    this.assignedEmployeeId = equipment?.assignedEmployeeId
    this.assignedEmployee = new AppUser(equipment?.assignedEmployee)
    this.dimensionSpecifications = new EquipmentDimensionSpecifications(
      equipment?.dimensionSpecifications
    )
    this.wheelsAndTiresSpecifications = new EquipmentWheelsAndTiresSpecifications(
      equipment?.wheelsAndTiresSpecifications
    )
  }
}

export default Equipment
